// function removeAnimation(el) {
//   el.classList.add('active');
// }

// let removeAnimate = document.querySelectorAll('.slider');

// const setAnimate  = setInterval(() => {
// 	if(removeAnimate.length) {
  		
//         removeAnimate.forEach(animate => {
// 			removeAnimation(animate)
//         })
//   		clearInterval(setAnimate);
//     } else {
// 		removeAnimate = document.querySelectorAll('.box__product-gallery slider');
//     }
// }, 200)

// window.addEventListener('load', () => {
//     setTimeout(() => {
//       if(removeAnimate.length === 0) {
// 			clearInterval(setAnimate);
//       }
// 	}, 1000)
// })


let xxi = 0;
let v = 0;
let colorIndex = 0;


// Purple: Centered, Focused
// Blue: Rested, Refreshed
// green: Rejuvenated, Energized
// pink: Beautiful, Confident
// orange: Relieved, Healthy

const txt = [
  ['Rested', '#4e738a'],
  ['Rejuvenated', '#94cfaf'],
  ['Relieved', '#ff7f30'],
  ['Beautiful', '#ffb1b9'],
  ['Focused', '#7c6990'],
  ['Refreshed', '#4e738a'],
  ['Energized', '#94cfaf'],
  ['Healthy', '#ff7f30'],
  ['Confident', '#ffb1b9']
]; /* The text */
let clr = ['#a28cd6', '#697ecb', '#7bc8a8', '#e79378', '#e7b0db']
let speed = 1100; /* The speed/duration of the effect in milliseconds */
const textParent = document.querySelector('#shopify-section-16138256261f0f471e .heading span');


let spars;

if(textParent) {
  for(let txtLength = 0; txtLength < txt.length; txtLength++) {
    const span = document.createElement('span');
    span.classList.add('hero-span');
    span.innerText = txt[txtLength][0];
    if(spars) {
     spars.insertAdjacentElement('afterend', span); 
    } else {
     textParent.insertAdjacentElement('afterend', span); 
    }
	spars = span;
    span.style.opacity = 0;
    span.style.color = txt[txtLength][1];
    span.style.borderBottom = '2px solid' + txt[txtLength][1];
  }
  textParent.classList.add('hero-span');
  textParent.style.color = '#7c6990';
  textParent.style.borderBottom = '2px solid' + '#7c6990';
}

window.addEventListener('load', () => { 
    setTimeout(() => {
      if(textParent) {                
        typeWriter()
//         setInterval(() => {
//             if(colorIndex + 1 < clr.length) {
//               colorIndex++ 
//             } else {
//               colorIndex = 0 
//             }
//               allSpans.forEach(sps => {
//                 sps.style.color = clr[colorIndex];
//                 sps.style.borderBottomColor = clr[colorIndex];
//               })
// 		}, 4400);
      }       
	}, 500)          
})


const allSpans = document.querySelectorAll('#shopify-section-16138256261f0f471e .heading span');

function typeWriter() {
    if(allSpans.length) {
        xxi = v;
        if(v + 1 < allSpans.length) {
         v++ 
        } else {
         v = 0 
        }

      	allSpans[xxi].style.opacity = 0;
      
        setTimeout(() => {
          allSpans[v].style.opacity = 1;
          setTimeout(typeWriter, speed); 
		}, 1100)      
             
    }
  }

$('.products').not(".-grid").slick({
  dots: false,
  infinite: true,
  speed: 300,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



  /* 
  $('.slider-for').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: true,
  centerMode: true,
  focusOnSelect: true
});
	*/
  
  $('.slider-for').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
      adaptiveHeight: true,
     responsive: [
       {
      breakpoint: 2960,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },  {
      breakpoint: 1660,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
       {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          adaptiveHeight: true

      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('._recipes').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3.1,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 610,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }
  ]
});
  

const readMore = document.querySelectorAll('.img-and-review a'); 
let stampWidgetparent = document.querySelector('#stamped-reviews-widget');
let stampWidgetChild = document.querySelector('#stamped-widget-drawer');

if(readMore.length) {
  readMore.forEach(more => {
    more.href = '';
    more.addEventListener('click', (ev) => {
      ev.preventDefault();
	  setTimeout(() => {
      if(!stampWidgetparent) {
        stampWidgetparent = document.querySelector('#stamped-reviews-widget');
        stampWidgetChild = document.querySelector('#stamped-widget-drawer');

        stampWidgetparent.classList.add('open');
        stampWidgetChild.classList.add('open');
      } else {
        stampWidgetparent.classList.add('open');
        stampWidgetChild.classList.add('open');
      }
    }, 400)

  }) 
}) 
}